import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Product } from '@app/forms/subscription/definition/interface/Pledge';

import { UntypedFormGroup } from '@angular/forms';
import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import {
  FundsOrigin,
  FundsOriginList,
} from '../../definition/interface/subscription';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'funds-initial-payment-scpi-form',
    templateUrl: './funds-initial-payment-scpi-form.component.html',
    styleUrls: ['./funds-initial-payment-scpi-form.component.scss'],
    standalone: false
})
export class FundsInitialPaymentScpiFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;

  @ViewChild('duplicateFundsOriginModal')
  duplicateFundsOriginModal: PrModalConfirmComponent;

  products: Product[] = [];
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.products = pledge?.products;

    this.initForm(pledge?.products);

    // this.subscriptionFacade.initForm(this);
  }

  // onSubmit() {

  //   if (
  //     this.scpis.controls[this.currentPageNumber]?.valid &&
  //     this.currentPageNumber == this.products.length - 1
  //   )
  //     this.subscriptionFacade.submitPledge(this, "products");

  //   if (
  //     this.scpis.controls[this.currentPageNumber]?.valid &&
  //     this.currentPageNumber < this.products.length - 1
  //   )
  //     this.currentPageNumber++;
  // }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (this.currentPageNumber == 0 && this.scpis.controls.length > 1) {
      this.duplicateFundsOriginModal.open();
      return;
    }

    this.submitForm();
  }
  submitForm() {
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.products.length - 1
    )
      this.subscriptionFacade.submitPledge(this, 'products');
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(
        this,
        'products',
        false,
        this.nextStep.bind(this),
        true,
      );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }

  onConfirmDuplicateFundsOrigin() {
    const firstParams = this.scpis.at(0).get('parameters') as UntypedFormGroup;
    const firstOrigins: FundsOriginList[] =
      firstParams.get('fundsOriginList').value;
    this.scpis.controls.forEach((scpiGroup, idx) => {
      if (idx > 0) {
        const params = scpiGroup.get('parameters') as UntypedFormGroup;
        params.setControl(
          'fundsOriginList',
          this.populate({ fundsOriginList: firstOrigins } as FundsOrigin, true),
        );
      }
    });

    this.subscriptionFacade.submitPledge(this, 'products');
  }

  onCancelDuplicateFundsOrigin() {
    this.submitForm();
  }
}
